import React, { useEffect, useState } from "react";
import backicon from "./../../../../../../Assets/icons/backIcon.svg";
// import "./index.scss";
import { useNavigate, useLocation } from "react-router-dom";
import DynamicForm from "../../../../../customformComponent/customForm/DynamicForm";
import axiosInstance from "../../../../../services/api/API";
import { showCustomAlert } from "../../../../../customComponents/CustomSweetAlert";
import { showErrorAlert } from "../../../../../customComponents/CustomSweetAlert/errorsweetalert";
import Loader from "../../../../../customComponents/CustomLoader";
import Swal from "sweetalert2";
import ROUTES_NAVIGATION from "../../../../../../routes/routes";
import validations from "../../../../../../helpers/validations";
import { buttonStyle, isFormValid } from "../../../../../../helpers/common";

const EditProduct = () => {
  const [formData, setFormData] = useState({});
  const navigate = useNavigate();
  const [validationErrors, setValidationErrors] = useState({});
  const location = useLocation();
  const { data } = location.state || {};
  console.log("dataaa", data);
  const [loading, setLoading] = useState(false);
  const userType = localStorage.getItem("UserType");
  const businessPartnerId = localStorage.getItem("business_partner_id");
  const authToken = localStorage.getItem("authToken");
  const [userTypedd, setUserTypedd] = useState([]);
  const [productOptions, setProductOptions] = useState([]);
  // const [unitOptions, setUnitOptions] = useState([]);
  const [warrantyOptions, setWarrantyOptions] = useState([]);
  const [hsncodeOptions, setHsncodeOptions] = useState([]);
  const [taxsetDropdown, setTaxSet] = useState([]);
  const [varientOptions, setVarientOptions] = useState([]);
  const [colorOptions, setColorOptions] = useState([]);
  const [modelOptions, setModelOptions] = useState([]);
  const [itemCategory, setItemcategoryOptions] = useState([]);

  useEffect(() => {
    fetchItemDD();
    // fetchUnitDD()
    fetchWarrrantyDD();
    fetchHsncodeDD();
    fetchTaxSetDropdown();
    // fetchModelOptions();
    // fetchVarientOptions();
    // fetchColorOptions();
    fetchTaxSetDropdown();
    fetchBatteryEdit();
    // fetchItemCategoryOptions();
  }, [formData?.business_partner_id]);

  useEffect(() => {
    fetchBatteryEdit();
  }, []);

  // const fetchModelOptions = async (makeId) => {
  //   try {
  //     const payload = {
  //       orderBy: "model_id desc",
  //       page: 0,
  //       pageSize: 100,
  //       make_id: makeId,
  //     };

  //     if (userType === "superadmin") {
  //       payload.business_partner_id = formData.business_partner_id;
  //     } else {
  //       payload.business_partner_id = businessPartnerId;
  //     }

  //     const response = await axiosInstance.post("/model/ddlmodel", payload, {
  //       headers: {
  //         "Content-Type": "application/json",
  //         Authorization: `Bearer ${authToken}`,
  //       },
  //     });

  //     const options = response.data.data.data.map((model) => ({
  //       label: model.NAME,
  //       value: model.ID,
  //     }));

  //     setModelOptions(options);
  //   } catch (error) {
  //     console.error("Error fetching model options:", error);
  //   }
  // };
  // const fetchVarientOptions = async (makeId) => {
  //   try {
  //     const payload = {

  //       page: 0,
  //       pageSize: 100,
  //       make_id: makeId,
  //     };

  //     if (userType === "superadmin") {
  //       payload.business_partner_id = formData.business_partner_id;
  //     } else {
  //       payload.business_partner_id = businessPartnerId;
  //     }

  //     const response = await axiosInstance.post(
  //       "/variant/ddlvariant",
  //       payload,
  //       {
  //         headers: {
  //           "Content-Type": "application/json",
  //           Authorization: `Bearer ${authToken}`,
  //         },
  //       }
  //     );

  //     const options = response.data.data.data.map((variant) => ({
  //       label: variant.NAME,
  //       value: variant.ID,
  //     }));

  //     setVarientOptions(options);
  //   } catch (error) {
  //     console.error("Error fetching model options:", error);
  //   }
  // };
  // // color options Api
  // const fetchColorOptions = async (makeId) => {
  //   try {
  //     const payload = {

  //       page: 0,
  //       pageSize: 100,
  //       make_id: makeId,
  //     };

  //     if (userType === "superadmin") {
  //       payload.business_partner_id = formData.business_partner_id;
  //     } else {
  //       payload.business_partner_id = businessPartnerId;
  //     }

  //     const response = await axiosInstance.post("/color/ddlcolor", payload, {
  //       headers: {
  //         "Content-Type": "application/json",
  //         Authorization: `Bearer ${authToken}`,
  //       },
  //     });

  //     const options = response.data.data.data.map((color) => ({
  //       label: color.NAME,
  //       value: color.ID,
  //     }));

  //     setColorOptions(options);
  //   } catch (error) {
  //     console.error("Error fetching model options:", error);
  //   }
  // };

  // const fetchItemCategoryOptions = async () => {
  //   try {
  //     const token = localStorage.getItem("authToken");
  //     const response = await axiosInstance.post(
  //       "/partcategory/ddlpartcategory",
  //       {
  //         // itemtype_id: itemtypeid,
  //         // variant_id:variantIdVal,
  //        },
  //       {
  //         headers: {
  //           "Content-Type": "application/json",
  //           Authorization: `Bearer ${token}`,
  //         },
  //       }
  //     );
  //     const options = response.data.data.data?.map((variant) => ({
  //       label: variant.NAME,
  //       value: variant.ID,
  //     }));
  //     setItemcategoryOptions(options);
  //   } catch (error) {
  //     console.error("Error fetching variant options:", error);
  //   }
  // };

  const fetchWarrrantyDD = async () => {
    try {
      const payload = {
        orderBy: "warranty_id desc",
        page: 0,
        pageSize: 100,
      };

      if (userType === "superadmin") {
        payload.business_partner_id = formData.business_partner_id;
      } else {
        payload.business_partner_id = businessPartnerId;
      }

      const response = await axiosInstance.post(
        "/warranty/ddlwarranty",
        payload,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${authToken}`,
          },
        },
      );

      const options = response.data.data.data.map((product) => ({
        label: product.NAME,
        value: product.ID,
      }));

      setWarrantyOptions(options);
    } catch (error) {
      console.error("Error fetching product options:", error);
    }
  };
  // const fetchUnitDD = async () => {
  //   try {

  //     const payload = {
  //       orderBy: 'unit_id desc',
  //       page: 0,
  //       pageSize: 100,
  //     }

  //     if (userType === "superadmin") {
  //       payload.business_partner_id = formData.business_partner_id;
  //     } else {
  //       payload.business_partner_id = businessPartnerId;
  //     }

  //     const response = await axiosInstance.post('/unit/ddlunit', payload, {
  //       headers: {
  //         "Content-Type": "application/json",
  //         Authorization: `Bearer ${authToken}`,
  //       }
  //     });

  //     const options = response.data.data.data.map(product => ({
  //       label: product.NAME,
  //       value: product.ID,
  //     }));

  //     setUnitOptions(options);
  //   } catch (error) {
  //     console.error('Error fetching product options:', error);
  //   }
  // };

  const fetchItemDD = async () => {
    try {
      const payload = {
        orderBy: "item_id desc",
        page: 0,
        pageSize: 100,
      };

      if (userType === "superadmin") {
        payload.business_partner_id = formData.business_partner_id;
      } else {
        payload.business_partner_id = businessPartnerId;
      }

      const response = await axiosInstance.post("/itemtype/list", payload, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${authToken}`,
        },
      });

      const options = response.data.data.data.map((product) => ({
        label: product.itemtype,
        value: product.itemtype_id,
      }));

      setProductOptions(options);
    } catch (error) {
      console.error("Error fetching product options:", error);
    }
  };

  const fetchTaxSetDropdown = async () => {
    try {
      const response = await axiosInstance.post(
        "/tax/ddltax",
        {},
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${authToken}`,
          },
        },
      );

      const formattedData = response?.data?.data?.data;
      console.log(formattedData, "VARIANTDATA");

      const variantData = formattedData.map((data) => ({
        value: data.ID,
        label: data.NAME,
        tax_percent: data?.tax_percent,
      }));

      setTaxSet(variantData);
    } catch (error) {
      console.error("Error fetching department list:", error);
    }
  };

  const fetchBatteryEdit = async () => {
    try {
      const response = await axiosInstance.get(
        `/battery/battery-detail/${data.batteryId}`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${authToken}`,
          },
        },
      );

      const fetchedData = response?.data?.data;
      console.log("fetchedData-->", fetchedData);
      const transformedData = {
        itemCode: fetchedData.item_code,
        purchasePrice: fetchedData.purchase_price,
        sellingPrice: fetchedData.selling_price,
        warranty: fetchedData.warrntyId,
        hsnCode: fetchedData.hsnCode_id,
        batteryType: fetchedData?.batteryType,
        // unitQuantity:fetchedData.Unit_id,
        taxid: fetchedData?.tax_id,
        // status: fetchedData.status === "Active" ? 1 : 0 ,
        status: fetchedData.status === 1 ? true : false,
        uploadImage: fetchedData?.item_image,
        battery_name: fetchedData?.battryName,
        batteryBrand: fetchedData?.brand_name,
      };
      setFormData(transformedData);
    } catch (error) {
      console.log(error);
    }
  };

  const handleFormSubmit = async (formData) => {
    console.log("itemdata", data);
    const errors = {};
    let isValid = true;

    ItemInputs.forEach((field) => {
      const value = formData[field.name];

      if (field.validation?.required && !value) {
        errors[field.name] = "This field is required";
        isValid = false;
        return;
      }

      if (
        value &&
        field.validation?.pattern &&
        !field.validation.pattern.test(value)
      ) {
        errors[field.name] = field.validation.message;
        isValid = false;
        return;
      }
    });

    if (
      formData.purchasePrice &&
      formData.sellingPrice &&
      Number(formData.purchasePrice) > Number(formData.sellingPrice)
    ) {
      errors.purchasePrice =
        "Purchase Price cannot be greater than Selling Price";
      isValid = false;
    }

    // If validation fails, set errors and return
    if (!isValid) {
      setValidationErrors(errors);
      return;
    }

    // const appendFileToFormData = async (formDataPayload, fileOrUrl) => {
    //   if (typeof fileOrUrl === "string" && fileOrUrl.startsWith("http")) {
    //     // Fetch the file from the URL and convert to Blob
    //     const response = await fetch(fileOrUrl);
    //     const blob = await response.blob();
    //     // You can give a default filename or extract from URL
    //     const filename = fileOrUrl.split("/").pop() || "batteryFile";
    //     formDataPayload.append("batteryFile", blob, filename);
    //   } else if (fileOrUrl instanceof File || fileOrUrl instanceof Blob) {
    //     formDataPayload.append("batteryFile", fileOrUrl);
    //   }
    // };

    const appendFileToFormData = async (formDataPayload, fileOrUrl) => {
      if (!fileOrUrl) {
        formDataPayload.append("batteryFile", 0);
        return;
      }

      if (typeof fileOrUrl === "string" && fileOrUrl.startsWith("http")) {
        const response = await fetch(fileOrUrl);
        const blob = await response.blob();
        const filename = fileOrUrl.split("/").pop() || "batteryFile";
        formDataPayload.append("batteryFile", blob, filename);
        return;
      }

      if (fileOrUrl instanceof File || fileOrUrl instanceof Blob) {
        formDataPayload.append("batteryFile", fileOrUrl);
        return;
      }

      formDataPayload.append("batteryFile", 0);
    };

    // SweetAlert confirmation before API call
    const result = await Swal.fire({
      title: "Confirmation",
      text: "Are you sure you want to update this record?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes",
      cancelButtonText: "No",
      showLoaderOnConfirm: true,
      allowOutsideClick: false,
      allowEscapeKey: false,
      preConfirm: async () => {
        try {
          setLoading(true);

          // Create FormData object
          const formDataPayload = new FormData();
          // formDataPayload.append("battery_name", formData.batteryName);
          if (formData.battery_name !== data.battery_name) {
            formDataPayload.append("battery_name", formData.battery_name);
          }
          formDataPayload.append("item_code", formData.itemCode);
          formDataPayload.append("selling_price", formData.sellingPrice);
          formDataPayload.append("purchase_price", formData.purchasePrice);
          formDataPayload.append("warranty_id", formData.warranty);
          formDataPayload.append("hsnCode_id", formData.hsnCode);
          formDataPayload.append("tax_id", formData.taxid);
          formDataPayload.append("batteryType", formData.batteryType);
          //  batteryType: data.batteryType,
          formDataPayload.append("status", formData.status === true ? 1 : 0);
          formDataPayload.append("brand_name", formData.batteryBrand);

          // Always append as binary
          await appendFileToFormData(formDataPayload, formData.uploadImage);

          const response = await axiosInstance.patch(
            `/battery/update-battery/${data.batteryId}`,
            formDataPayload,
            {
              headers: {
                "Content-Type": "multipart/form-data",
                Authorization: `Bearer ${authToken}`,
              },
            },
          );

          console.log("API Response:", response.data);

          // Success alert after update
          // showCustomAlert({
          //   title: "Success",
          //   text: "Item updated successfully.",
          //   icon: "success",
          //   confirmButtonText: "OK",
          //   callback: () => {
          //     navigate(ROUTES_NAVIGATION.BATTERYLIST); // Navigate after user clicks OK
          //   },
          // });

          if (response.status === 200) {
            Swal.fire({
              title: "Success",
              text: "Battery updated successfully!",
              icon: "success",
              confirmButtonText: "OK",
              allowOutsideClick: false,
              allowEscapeKey: false,
            }).then(() => {
              navigate(ROUTES_NAVIGATION.BATTERYLIST);
            });
          }
        } catch (error) {
          console.error("Error submitting form:", error);

          // Error alert
          const errorMessage = error.response?.data?.message;
          showErrorAlert({
            title: "Something went wrong",
            text:
              errorMessage ||
              "An error occurred while processing your request.",
            callback: () => {
              console.log("Error alert confirmed");
            },
          });
        } finally {
          setLoading(false);
        }
      },
    });
  };

  const fetchHsncodeDD = async () => {
    try {
      const payload = {
        orderBy: "hsncode_id desc",
        page: 0,
        pageSize: 100,
      };

      if (userType === "superadmin") {
        payload.business_partner_id = formData.business_partner_id;
      } else {
        payload.business_partner_id = businessPartnerId;
      }

      const response = await axiosInstance.post(
        "/hsncode/ddlhsncode",
        payload,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${authToken}`,
          },
        },
      );

      const options = response.data.data.data.map((product) => ({
        label: product.NAME,
        value: product.ID,
      }));

      setHsncodeOptions(options);
    } catch (error) {
      console.error("Error hsncode options:", error);
    }
  };

  const ItemInputs = [
    {
      name: "battery_name",
      label: "Battery Name",
      placeholder: "Enter Battery Name",
      type: "text",
      required: true,
      validation: validations.batteryName({ required: true }),
      gridClass: "col-lg-4",
      disabled: true,
    },
    {
      name: "batteryBrand",
      label: "Battery Brand",
      placeholder: "Enter Battery Brand Name",
      type: "text",
      required: true,
      validation: validations.batteryBrandName({ required: true }),
      gridClass: "col-lg-4",
    },
    {
      name: "batteryType",
      label: "Battery Type",
      placeholder: "Enter",
      type: "dropdown",
      options: [
        { value: "L", label: "Lithium Battery" },
        { value: "G", label: "Graphene Battery" },
        { value: "N", label: "No Battery" },
      ],
      required: true,
      gridClass: "col-lg-4",
      validation: { required: true },
    },
    {
      name: "purchasePrice",
      label: "Purchase Price",
      placeholder: "Enter Purchase Price",
      type: "text",
      validation: validations.price({ required: true }),
      required: true,
      gridClass: "col-lg-4",
    },
    {
      name: "sellingPrice",
      label: "Selling Price",
      placeholder: "Enter Selling Price",
      type: "text",
      validation: validations.price({ required: true }),
      required: true,
      gridClass: "col-lg-4",
    },
    {
      name: "warranty",
      label: "Warranty",
      type: "dropdown",
      required: true,
      options: warrantyOptions,
      validation: {
        required: true,
      },
      gridClass: "col-lg-4",
    },
    {
      name: "taxid",
      label: "Tax",
      type: "dropdown",
      required: true,
      options: taxsetDropdown,
      validation: {
        required: true,
      },
      gridClass: "col-lg-4",
    },
    {
      name: "hsnCode",
      label: "HSN Code",
      //placeholder: "Enter HSN Code",
      type: "dropdown",
      options: hsncodeOptions,
      validation: {
        required: true,
        // pattern: /^[0-9\s]*$/,
        //message: "Only Digits are allowed*",
      },
      required: true,
      gridClass: "col-lg-4",
    },
    {
      name: "uploadImage",
      label: "Upload",
      type: "file",
      // required: true,
      validation: {
        // required: true,
      },
      gridClass: "col-lg-4",
      allowedExtensions: ["jpg", "jpeg", "png", "pdf"],
    },
    {
      name: "status",
      label: "Status",
      type: "toggle",
      gridClass: "col-lg-4",
    },
  ];

  return (
    <>
      <div>
        {loading ? (
          <Loader />
        ) : (
          <>
            <div
              className="backbutton mt-2 mb-2"
              // onClick={() => navigate(ROUTES_NAVIGATION.BATTERYLIST)}
            >
              <img
                style={{ cursor: "pointer" }}
                onClick={() => navigate(-1)}
                src={backicon}
                alt="back"
              />
              <span className="backbtntitle">Edit Battery</span>
            </div>
            <div className="form-container">
              <span className="cust-det-title mt-2 mb-2">
                Please Enter Item Details
              </span>
              <DynamicForm
                validateOnMount
                formConfig={ItemInputs}
                formData={formData}
                setFormData={setFormData}
                onSubmit={handleFormSubmit}
                validationErrors={validationErrors}
                setValidationErrors={setValidationErrors}
              />
            </div>
            <div className="btncontainer mt-3">
              <button
                className="submit-btn"
                disabled={
                  !isFormValid(ItemInputs, formData, validationErrors) ||
                  loading
                }
                style={buttonStyle(
                  ItemInputs,
                  formData,
                  validationErrors,
                  loading,
                )}
                onClick={() => handleFormSubmit(formData)}
              >
                {loading ? "Processing..." : "Submit"}
              </button>
            </div>
          </>
        )}
      </div>
    </>
  );
};

export default EditProduct;
